import { Dialog } from '@mui/material';

export default Dialog;
